import type { SubCustomersTranslations } from './types'

export const urTranslations: SubCustomersTranslations = {
  title: 'گاہک',
  subtitle: 'اپنے گاہکوں کا انتظام کریں',
  addCustomer: 'گاہک شامل کریں',
  editCustomer: 'گاہک میں ترمیم کریں',
  deleteCustomer: 'گاہک حذف کریں',
  customerCode: 'کوڈ',
  customerName: 'نام',
  customerPhone: 'فون',
  selectCustomer: 'گاہک منتخب کریں',
  changeCustomer: 'گاہک تبدیل کریں',
  noCustomer: 'کوئی گاہک تفویض نہیں',
  addNewCustomer: 'نیا گاہک شامل کریں',
  createNewCustomer: 'نیا گاہک بنائیں',
  hideCreate: 'چھپائیں',
  namePlaceholder: 'گاہک کا نام درج کریں',
  phonePlaceholder: 'فون نمبر درج کریں (اختیاری)',
  searchPlaceholder: 'گاہکوں میں تلاش کریں...',
  noCustomersFound: 'کوئی گاہک نہیں ملا',
  deleteConfirmTitle: 'گاہک حذف کریں',
  deleteConfirmDescription: 'کیا آپ واقعی اس گاہک کو حذف کرنا چاہتے ہیں؟',
  saveSuccess: 'گاہک کامیابی سے محفوظ ہوگیا',
  saveError: 'گاہک محفوظ کرنے میں ناکامی',
  deleteSuccess: 'گاہک کامیابی سے حذف ہوگیا',
  deleteError: 'گاہک حذف کرنے میں ناکامی',
}
